<template>
  <div style="overflow: scroll">
    <div class="base-info">
      <!-- {{ hospitalInfo.hospitalName }} -->
      <div @click="showPicker = true" class="inspection-name">
        <div class="van-ellipsis" style="width: 90%">
          {{ currentItem.title }}
        </div>
        <van-icon name="arrow-down" color="white" />
      </div>
      <div style="display: flex">
        <span>{{ userInfo.patientName }} {{ userInfo.cardNo }}</span>
        <span style="margin-left: auto">{{
          date.replace(/(.{2})(.{2})/, "$1月$2日")
        }}</span>
      </div>
    </div>
    <div v-if="itype != '2'">
      <div
        v-for="(item, index) in inspectionDetailList"
        :key="index"
        class="item-list"
      >
        <div :class="[item.resultFlag != '' ? 'item-value-up' : '']">
          {{ item.name }}
          <span>
            {{ item.value }}
            <span style="margin-left: 6px; font-size: 1rem; color: red">{{
              item.resultFlag
            }}</span>
            <!-- <span
              v-if="item.departure == 1"
              style="margin-left: 6px; font-size: 1rem"
              >↑</span
            >
            <span
              v-if="item.departure == -1"
              style="margin-left: 6px; font-size: 1rem"
              >↓</span
            > -->
          </span>
        </div>
        <div style="display: flex; font-size: 0.94rem">
          <div style="width: 65%; color: #a0a0a0">
            参考值： {{ item.referenceRange }}
          </div>
          <span style="margin-left: auto">单位：{{ item.unit }}</span>
        </div>
      </div>
    </div>
    <div v-if="itype == '2'">
      <div
        v-for="(item, index) in inspectionDetailList"
        :key="index"
        class="item-list"
      >
        <div>
          细菌名称：{{ item.name }}
          <span> 细菌结果：{{ item.result }} </span>
        </div>
        <div style="display: flex; font-size: 0.94rem">
          <div>是否多重耐药： {{ item.sfny }}</div>
        </div>
        <div style="display: flex; font-size: 0.94rem">
          <span>药敏结果：{{ item.ymjg }}</span>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        :columns="getReportList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      inspectionDetailList: [],
      query: {},
      currentItem: {},
      list: [],
      userInfo: {},
      showPicker: false,
      date: "",
      itype: "1",
    };
  },
  computed: {
    // ...mapState({
    //   hospitalInfo: state => state.home.hospitalInfo
    // }),
    getReportList() {
      return this.list.map((item) => {
        return {
          text: item.title,
          ...item,
        };
      });
    },
  },
  created() {
    const { currentItem, list, date, ftype } = this.$route.query;
    this.currentItem = currentItem;
    this.list = list;
    this.date = date;
    console.log("currentItem", currentItem);
    this.getInspectionsDetail(currentItem);
    this.itype = currentItem.inspectionType;
    this.getUserBaseInfo(ftype).then((res) => {
      this.userInfo = res;
    });
  },
  methods: {
    ...mapActions("users", ["getUserBaseInfo"]),
    onConfirm(item) {
      this.showPicker = false;
      this.currentItem = item;
      this.getInspectionsDetail(item);
    },
    getInspectionsDetail(param) {
      this.$http
        .post(this.$api.REPORT_INSPECTION_DETAIL, {
          reportSerialNo: param.id,
          inspectionType: param.inspectionType,
        })
        .then((res) => {
          const list = res.map((item) => {
            // 偏离度 0 不变 1 上升 -1 下降
            let departure = 0;
            if (item.normalValue === "↑") {
              departure = 1;
            }
            if (item.normalValue === "↓") {
              departure = -1;
            }
            if (this.itype != "2") {
              return {
                name: item.projectName || item.testItemName,
                value: item.inspectionResult,
                referenceRange: item.referenceRange,
                unit: item.jgdw00 || item.testItemUnit,
                resultFlag: item.resultFlag,
                departure,
              };
            } else {
              return {
                name: item.projectName,
                result: item.result,
                sfny: item.drugFast,
                ymjg: item.drugSensitivity,
              };
            }
          });
          this.inspectionDetailList = list;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.base-info {
  padding: 10px;
  color: white;
  background: @primary-blue;
}
.inspection-name {
  display: flex;
  margin: 4px 0;
  color: white;
  span {
    font-size: 0.94rem;
  }
}

.item-list {
  margin: 12px;
  padding-bottom: 12px;
  border-bottom: solid 0.67px #dcdcdc;

  div {
    line-height: 1.5rem;
  }

  span {
    float: right;
    // color: #959595;
    font-size: 0.88rem;
  }
}

.item-value-up {
  color: red;

  span {
    color: red;
  }
}

.item-value-down {
  color: blue;

  span {
    color: blue;
  }
}
</style>
